import * as z from "zod";

export const putIndigo8Integration = {
  name: "putIndigo8Integration" as const,
  input: z.object({
    apiKey: z.string().optional(),
    baseUrl: z.string(),
    shopifyShopName: z.string().optional(),
    createReturnsEnabled: z.boolean(),
    processReturnsEnabled: z.boolean(),
  }),
  output: z.object({}),
};
